import React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';

const InboxOutlined = ({
    stroke = '#D9D9D9',
    customIndex,
    className,
    style,
}: {
    stroke?: string;
    customIndex?: number;
    className?: string;
    style?: React.CSSProperties;
}) => {
    const iconIndex = customIndex ?? chooseIconIndex();

    const pathContent = (
        <>
            <path d="M13.5 43.2737C5.14272 45.1478 0 47.7009 0 50.5147C0 56.2665 21.4903 60.9293 48 60.9293C74.5097 60.9293 96 56.2665 96 50.5147C96 47.7009 90.8573 45.1478 82.5 43.2737V47.8138C82.5 50.9724 80.52 53.5612 78.075 53.5612H17.925C15.48 53.5612 13.5 50.9709 13.5 47.8138V43.2737Z" fill="black" fillOpacity="0.06" />
            <path d="M62.4195 25.1901C62.4195 22.8022 63.9105 20.8308 65.76 20.8293H82.5V47.8137C82.5 50.9723 80.52 53.561 78.075 53.561H17.925C15.48 53.561 13.5 50.9708 13.5 47.8137V20.8293H30.24C32.0895 20.8293 33.5805 22.7977 33.5805 25.1856V25.2184C33.5805 27.6063 35.088 29.5345 36.936 29.5345H59.064C60.912 29.5345 62.4195 27.5884 62.4195 25.2005V25.1901Z" fill="black" fillOpacity="0.04" stroke={stroke} />
            <path d="M82.5 20.9937L67.281 3.88094C66.5505 2.7145 65.484 2.00928 64.3605 2.00928H31.6395C30.516 2.00928 29.4495 2.7145 28.719 3.87945L13.5 20.9952" stroke={stroke} />
        </>
    );

    const svgProps = { viewBox: '0 0 96 61', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', className, style };

    // 2K
    if (iconIndex === 1) {
        return (
            <svg {...svgProps} width="32" height="20">
                {pathContent}
            </svg>
        );
    }
    // 4K
    if (iconIndex === 2) {
        return (
            <svg {...svgProps} width="48" height="31">
                {pathContent}
            </svg>
        );
    }
    // BELOW 2K
    return (
        <svg {...svgProps} width="96" height="61">
            {pathContent}
        </svg>
    );
};

export default InboxOutlined;
